import { DotMatrix, PageHeader } from '@clickguard/design-system'
import { PageTitle } from '../../../../utils/page-title'
import { lazy, Suspense } from 'react'
import RemoveWebsiteSection from './remove-website/remove-website'
import { GTextWithExternalLink } from '../../../../components/basic-blocks'
import { useAssetStore } from '../../../../store'
import { useShallow } from 'zustand/react/shallow'

const FormSection = lazy(() =>
	import('./form-section')
		.then((module) => {
			return { default: module.FormSection }
		})
		.catch((error) => {
			console.error('Failed to load:', error)
			return { default: () => <div>Error loading the component.....</div> }
		})
)

export const AssetSettingsPage = () => {
	const { asset, demoMode } = useAssetStore(
		useShallow((s) => ({
			asset: s.asset,
			demoMode: s.demoMode
		}))
	)
	return (
		<div className="w-full">
			<PageTitle pageName="Website preferences" />
			<PageHeader
				layout="stacked"
				title={'Website preferences'}
				subtitle={
					<span className="inline-flex items-center text-t-checkbox-unactive">
						<span className="font-normal">
							Configure basic preferences for&nbsp;
						</span>
						<GTextWithExternalLink
							text={demoMode ? 'Demo PPC account' : asset?.name}
							className="font-medium max-w-[200px] truncate inline-block"
							showIcon={!demoMode}
						/>
					</span>
				}
			/>
			<div className="pt-4">
				<>
					<Suspense
						fallback={
							<div className="flex justify-center py-16">
								<DotMatrix size="lg" />
							</div>
						}
					>
						<FormSection />
					</Suspense>
					<RemoveWebsiteSection />
				</>
			</div>
		</div>
	)
}
